import React from 'react'
import { Col, Row } from 'react-bootstrap'

export const LMWDataGet = ({ indicatorCount, countryCount }) => {
    return (
      <div>
        <Row className='py-5'>
          <Col md={6} sm={1} className='d-flex flex-column align-items-center'>
            <div className='about-content'>
              <img className='pe-4 about-icon' src="/static/calendar.svg" alt='' />
              <div>
                <h1>1990–2026</h1>
                <p>Period Covered</p>
              </div>
            </div>
            <div className='about-content'>
              <img src="/static/globe.svg" className='pe-4 about-icon' alt='' />
              <div>
                <h1>{countryCount ?? '—'}</h1>
                <p>Countries</p>
              </div>
            </div>
          </Col>
          <Col md={6} sm={1} className='d-flex flex-column align-items-center'>
            <div className='about-content'>
              <img src="/static/server.svg" className='pe-4 about-icon' alt='' />
              <div>
                <h1>{indicatorCount != null ? `${indicatorCount}+` : '—'}</h1>
                <p>Indicators</p>
              </div>
            </div>
            <div className='about-content'>
              <img src="/static/database.svg" className='pe-4 about-icon' alt='' />
              <div>
                <h1>Public</h1>
                <p>Access</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
};
